export default __webpack_public_path__ + "static/media/alert_icon.95eca0d5.svg";